import { action } from 'satcheljs';

/**
 * Action to notify that the calendar selection completed.
 */
const calendarSelectionCompleted = action('calendarSelectionCompleted');

export default calendarSelectionCompleted;
